import { createContext, useContext } from "react";

// Lets other auto-opening UI (the tutorial tours) yield to the survey.
// surveyResolved flips true once eligibility is known, whether or not the
// survey opens; surveyOpen is true while the modal is on screen. Defaults
// mean "no survey here" so consumers work anywhere the provider isn't
// mounted.
export type SurveyGate = { surveyOpen: boolean; surveyResolved: boolean };

export const SurveyGateContext = createContext<SurveyGate>({
  surveyOpen: false,
  surveyResolved: true,
});

export const useSurveyGate = () => useContext(SurveyGateContext);
